var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalRows > 10)?_c('div',{staticClass:"sb-nav-pagination"},[_c('b-pagination',{attrs:{"size":"sm","value":_vm.value,"total-rows":_vm.totalRows,"per-page":10,"first-number":"","last-number":"","align":"left"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }